// extracted by mini-css-extract-plugin
export default {"layout":"PublicLayout_layout__UskA7","wrapper":"PublicLayout_wrapper__qguC8","logo":"PublicLayout_logo__7ao01","logoText":"PublicLayout_logoText__LRGny"};